/* eslint-disable */

import React, { useState } from 'react'
import cn from 'classnames'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

import { css, StyleSheet } from 'aphrodite'
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { useLoad } from '../hooks/request'
import { BORROW_LIST, CLIENT_DETAIL } from '../urls'
import empty from '../static/empty-product.png'
import Table from './common/Table'
import ClientBorrowItem from './ClientBorrowItem'
import { useQueryParams } from '../hooks/queryString'
import BorrowOutCreate from './BorrowOutCreate'
import Button from './common/Button'
import { useCustomModal } from '../hooks/customModal'
import Layout from './Layout'
// import { measurement } from '../utils/position'
import BorrowInCreate from "./BorrowInCreate";

pdfMake.vfs = pdfFonts.pdfMake?.vfs

export default function ClientBorrowList() {
    const { clientId } = useParams()
    const { params } = useQueryParams()
    const [page, setPage] = useState(1)
    const { response: client } = useLoad({ url: CLIENT_DETAIL.replace('{id}', clientId) })
    const borrows = useLoad({ url: BORROW_LIST, params: { page, ...params, client_id: clientId, status: 'active' } }, [params, page])
    const borrowItem = borrows.response ? borrows.response.results : []

    const totalSumIn = borrows.response?.totalSumIn || 0
    const totalUsdIn = borrows.response?.totalUsdIn || 0
    const totalSumOut = borrows.response?.totalSumOut || 0
    const totalUsdOut = borrows.response?.totalUsdOut || 0
    const totalSum = borrows.response?.totalSum || 0
    const totalUsd = borrows.response?.totalUsd || 0
    const [showCreateModal, hideCreateModal] = useCustomModal(<BorrowOutCreate borrows={borrows} clientId={clientId} onCancel={() => hideCreateModal()} />, styles.modal)
    const [showPayModal, hidePayModal] = useCustomModal(<BorrowInCreate borrow borrows={borrows} clientId={clientId}
        onCancel={() => hidePayModal()} />, styles.modal)
    const formatNumber = (num) => {
        return new Intl.NumberFormat('ru-RU').format(num)
    }
    /*    const exportToPdf = () => {
            const res = allBorrows?.map((item) => {
                const { selectOrder } = item
                const orderItems = selectOrder?.orderProduct || []
    
                const amount = formatNumber(item.amount)
                const currency = item.currency === 'sum' ? 'Сум' : 'USD'
    
                return [
                    { text: 'Товары', style: 'sectionTitle' },
                    {
                        table: {
                            headerRows: 1,
                            widths: [30, '*', 50, 50, 60, 50],
                            body: [
                                [
                                    { text: '№', style: 'tableHeader' },
                                    { text: 'Наименование', style: 'tableHeader' },
                                    { text: 'Ед. изм', style: 'tableHeader' },
                                    { text: 'Кол-во', style: 'tableHeader' },
                                    { text: 'Цена', style: 'tableHeader' },
                                    { text: 'Сумма', style: 'tableHeader' },
                                ],
                                ...orderItems.map((product, index) => [index + 1, product.product.name, measurement(product.product.measurement), product.count, formatNumber(product.price), formatNumber(product.price * product.count)]),
                            ],
                        },
                    },
                    { text: ' ' },
                    {
                        columns: [
                            { text: 'Итого:', alignment: 'right', style: 'totalsLabel' },
                            { text: amount + ' ' + currency, alignment: 'right', style: 'totalsValue' },
                        ],
                    },
                ]
            })
    
            const docDefinition = {
                content: [
                    { text: 'СЧЕТ-ФАКТУРА', style: 'header' },
                    { columns: [{ text: 'Поставщик' }, { text: 'SKLAT', bold: true }] },
                    { columns: [{ text: 'Адрес' }, { text: 'SHOFIRKON', bold: true }] },
                    { text: 'Покупатель', style: 'sectionTitle' },
                    { columns: [{ text: `${client?.name} ${client?.phoneNumber}` }, { text: `Контакт: ${client?.phoneNumber}` }] },
                    { text: ' ' },
                    ...res.flat(),
                ],
                styles: {
                    header: { fontSize: 18, bold: true, marginBottom: 10 },
                    subheader: { fontSize: 12, marginBottom: 5 },
                    sectionTitle: { fontSize: 14, bold: true, marginTop: 10, marginBottom: 5 },
                    tableHeader: { bold: true, fontSize: 12, color: 'black' },
                    totalsLabel: { bold: true, fontSize: 12, marginTop: 10 },
                    totalsValue: { bold: true, fontSize: 12, marginTop: 10 },
                },
            }
    
            pdfMake.createPdf(docDefinition).download(`invoice_${client.id}.pdf`)
        }*/

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    return (
        <Layout>
            <header className="mb-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <hgroup style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <Link className="is-white is-link is-outlined" to="/borrow">
                        <i className="icon ion-md-arrow-back is-size-4" />
                    </Link>
                    <span className="is-size-4 is-uppercase">
                        <b>
                            {client?.name} - {client?.phoneNumber}
                        </b>
                    </span>

                    <Button onClick={showPayModal} text="Оплатить "
                        className="is-link is-outlined" />
                    <Button onClick={showCreateModal} text="Задолженность"
                        className="is-link is-outlined" />
                    {/*<Button text="PDF" onClick={exportToPdf} className="is-link is-outlined is-size-6"/>*/}
                </hgroup>


            </header>
            <div style={{
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '12px',
                padding: '24px',
                marginTop: '24px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                width: '100%'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '24px',
                    width: '100%'
                }}>
                    {/* Total Amount Section */}
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        border: '1px solid #e3f2fd',
                        borderLeft: '4px solid #007bff'
                    }}>
                        <h3 style={{
                            margin: '0 0 12px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#007bff',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span>💼</span>
                            Общая сумма
                        </h3>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px'
                        }}>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                -{format(totalUsd)} USD
                            </span>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                -{format(totalSum)} Сум
                            </span>
                        </div>
                    </div>

                    {/* Debt Section */}
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        border: '1px solid #fee2e2',
                        borderLeft: '4px solid #dc3545'
                    }}>
                        <h3 style={{
                            margin: '0 0 12px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#dc3545',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span>📋</span>
                            Сумма долга
                        </h3>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px'
                        }}>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                {format(totalUsdOut)} USD
                            </span>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                {format(totalSumOut)} Сум
                            </span>
                        </div>
                    </div>

                    {/* Payment Section */}
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        border: '1px solid #d4edda',
                        borderLeft: '4px solid #28a745'
                    }}>
                        <h3 style={{
                            margin: '0 0 12px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#28a745',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span>💰</span>
                            Оплачено
                        </h3>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px'
                        }}>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                {format(totalUsdIn)} USD
                            </span>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#2d3748'
                            }}>
                                {format(totalSumIn)} Сум
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            {borrows.response && borrows.response.count === 0 ? (
                <div>
                    <div className="is-flex is-justify-content-center is-align-items-center">
                        <h1>
                            <b>Не долг</b>
                        </h1>
                    </div>
                    <div className="is-flex is-justify-content-center is-align-items-center">
                        <img alt="empty" src={empty} className={cn(css(styles.emptyImg), 'is-horizontal-center')} />
                    </div>
                </div>
            ) : (
                <div className="">
                    <Table

                        loading={borrows.loading}
                        items={borrowItem}
                        columns={{
                            number: '№',
                            amountIn: 'Сумма долга',
                            amountOut: 'Оплачено',
                            name: 'Способ оплаты',
                            status: 'Статус',
                            registeredAt: 'Дата',
                            actions: 'Действие',
                        }}
                        totalCount={borrows.response ? borrows.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) => <ClientBorrowItem model index={index} borrows={borrows}
                            clientId={clientId} key={item.id} item={item} />}
                    />


                </div>
            )}


        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 }
})
